export default function SecondaryNav({ tabs, active, onChange, testid }) {
  return (
    <nav
      className="border-b border-border -mx-5 md:-mx-10 px-5 md:px-10 mb-8"
      data-testid={testid}
      aria-label="Sekundäre Navigation"
    >
      <div className="flex items-center gap-1 overflow-x-auto">
        {tabs.map((t) => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              onClick={() => onChange(t.key)}
              className={`relative px-3 py-3 text-sm whitespace-nowrap transition-colors ${
                isActive
                  ? "text-foreground"
                  : "text-muted-foreground hover:text-foreground"
              }`}
              data-testid={`secondary-nav-${t.key}`}
              aria-current={isActive ? "page" : undefined}
            >
              <span className="inline-flex items-center gap-1.5">
                {t.label}
                {typeof t.count === "number" && (
                  <span className="text-[11px] text-muted-foreground/80 font-mono">
                    {t.count}
                  </span>
                )}
              </span>
              {isActive && (
                <span
                  className="absolute left-2 right-2 -bottom-px h-[2px] rounded-full bg-primary/90"
                  aria-hidden="true"
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
